"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _permission = _interopRequireDefault(require("./permission"));
var install = function install(Vue) {
  Vue.directive('FPermission', _permission.default);
};
if (window.Vue) {
  window['FPermission'] = _permission.default;
  Vue.use(install); // eslint-disable-line
}
_permission.default.install = install;
var _default = exports.default = _permission.default;